import { render, staticRenderFns } from "./DetailEventChartPanel.vue?vue&type=template&id=ab8673c4&scoped=true&"
import script from "./DetailEventChartPanel.vue?vue&type=script&lang=js&"
export * from "./DetailEventChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailEventChartPanel.vue?vue&type=style&index=0&id=ab8673c4&lang=scss&scoped=true&"
import style1 from "./DetailEventChartPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8673c4",
  null
  
)

export default component.exports